module.exports = __webpack_public_path__ + "static/media/Artboard6.a68b494f.png";